import React, { Component } from 'react'

export class AppFileUploader extends Component {
    constructor(props) {
        super(props);
        let { name, group, documentKey } = props.uploadpayload.doc_meta_name;
        let inprops = app.appstore(`uploads.${group}.${documentKey}.${name}`) || {}
        this.state = {
            inprops: inprops
        }
        window.AppFileUploader = this;
    }

    onFileUpload(data) {
        let { props } = this;
        let payload = {
            isuploaded: true,
            "data-invalue": data[props.file_id_key || 'attachment_id'],
            "data-filename": data[props.file_name_key || 'file_name'],
            labelname: data[props.file_name_key || 'file_name'],
            password:data[data.password_key||'password']
        };
        let { name, group, documentKey } = props.uploadpayload.doc_meta_name;
        console.log({name, group, documentKey },props.uploadpayload);
        app.store(`uploads.${group}.${documentKey}.${name}`,payload);
        this.props.onFetchDocList && this.props.onFetchDocList();
        success("Upload Successfull").promise.then(() => {
            //this.props.onFetchDocList && this.props.onFetchDocList();
        });
    }

    uploadDocument(event) {
        let { props } = this;
        let input = event.target;
        let [file] = input.files;
        let uploadpayload = structuredClone(props?.uploadpayload);
        if(uploadpayload) {
            uploadpayload.doc_meta_name = (typeof uploadpayload.doc_meta_name=="string")?uploadpayload.doc_meta_name:JSON.stringify(uploadpayload.doc_meta_name).encode();
        }
        let payload = {
            ...(uploadpayload || {}),
            file
        };
        app.api.execApi((props.uploadEndpoint || "postDocument"), payload, {}, {
            multipart: true,
            message: "Uploading please wait...",
        }).then((response)=>{
            this.onFileUpload(response.data);
        });
    }

    deleteDocument(args) {
        let { props } = this;
        let { name, group, documentKey } = props.uploadpayload.doc_meta_name;
        console.log({ name, group, documentKey });
        let payload = { [(props.file_id_key || 'attachment_id')]: args['data-invalue'] };
        app.api.execApi((props.deleteEndpoint || "deleteDocument"), {}, payload).then(() => {
            app.store(`uploads.${group}.${documentKey}.${name}.isuploaded`,false);
            app.store(`uploads.${group}.${documentKey}.${name}.labelname`,'');
            this.setState((state)=>({
                inprops:{
                    ...state.inprops,
                    isuploaded:false,
                    labelname:''
                }
            }));
            this.props.onFetchDocList && this.props.onFetchDocList();
        });
    }

    downloadDocument(args) {
        let { props } = this;
        let url = app.api.getUrl((props.downloadEndpoint || "getDocument"), {
            [(props.file_id_key || 'attachment_id')]: args['data-invalue']
        });
        window.open(url);
    }

    render() {
        let { props } = this;
        return (
            <div {...Object.only(props, [])}>
                <input type='hidden' name={props.name+".attachment_id"} value={this.state.inprops['data-invalue']}></input>
                <input type='hidden' name={props.name+".filename"} value={this.state.inprops['data-filename']}></input>
                <input type='hidden' name={props.name+".password"} value={this.state.inprops.password}></input>
                {
                    props.intype == "file" ?
                    <AppUpload
                        {...Object.except(props, ['node','onFetchDocList','deleteEndpoint','uploadEndpoint'])}
                        attachname="file"
                        {...({
                            onChange: (e) => this.uploadDocument(e),
                            onDelete: (...args) => this.deleteDocument(...args),
                            onDownload: (...args) => this.downloadDocument(...args),
                        })}
                        {...this.state.inprops}
                    /> :
                    <AppUploadPassword
                        {...Object.except(props, ['node','onFetchDocList','deleteEndpoint','uploadEndpoint'])}
                        attachname="file"
                        {...({
                            onChange: (e) => this.uploadDocument(e),
                            onDelete: (...args) => this.deleteDocument(...args),
                            onDownload: (...args) => this.downloadDocument(...args),
                        })}
                        {...this.state.inprops}
                        from={"AppInput"}
                    >
                    </AppUploadPassword>
                }
            </div>
        )
    }
}

export default AppFileUploader